module.exports = __webpack_public_path__ + "static/media/coo.4a485e32.jpg";